export const actions = {
    // cities
    GET_CITIES: 'GET_CITIES',
    GET_CITIES_SUCCESS: 'GET_CITIES_SUCCESS',
    GET_CITIES_FAILED: 'GET_CITIES_FAILED',
    // home faqs
    GET_HOME_FAQS: 'GET_HOME_FAQS',
    GET_HOME_FAQS_SUCCESS: 'GET_HOME_FAQS_SUCCESS',
    GET_HOME_FAQS_FAILED: 'GET_HOME_FAQS_FAILED',
    // Address layout
    SET_ADDRESS_LAYOUT: 'SET_ADDRESS_LAYOUT',
}

// cities
export const getCitiesData = countryCode => ({
    type: actions.GET_CITIES,
    countryCode,
})

export const getCitiesDataSuccess = payload => ({
    type: actions.GET_CITIES_SUCCESS,
    payload,
})

export const getCitiesDataFailed = () => ({
    type: actions.GET_CITIES_FAILED,
})

// home faqs
export const getHomeFaqsData = language => ({
    type: actions.GET_HOME_FAQS,
    language,
})

export const getHomeFaqsDataSuccess = payload => ({
    type: actions.GET_HOME_FAQS_SUCCESS,
    payload,
})

export const getHomeFaqsDataFailed = () => ({
    type: actions.GET_HOME_FAQS_FAILED,
})

export const setAddressLayout = payload => ({
    type: actions.SET_ADDRESS_LAYOUT,
    payload,
})
